const postulacion = {
  preguntasObligatorias: {
    enabled: false,
  },
}
export default postulacion
